
import React from 'react';
import { ArrowRight } from 'lucide-react';

const IntroSection = () => {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="reveal">
            <div className="inline-block px-3 py-1 rounded-full bg-primary/10 text-primary text-xs font-medium mb-4">
              Data-Driven Operations
            </div>
            <h2 className="text-3xl md:text-4xl font-semibold mb-6">
              Transform Your Organization with a Custom Data Platform
            </h2>
            <p className="text-lg text-muted-foreground mb-6">
              Our Tailored Organisational Data Platform provides a structured approach to elevate your organization to truly data-driven operations. 
              We guide you through every step from use case definition to implementation and adoption.
            </p>
            <p className="text-lg text-muted-foreground mb-8">
              With a dedicated Customer Success Manager ensuring adoption and maximizing value from your investment, 
              you can focus on what matters most - making informed business decisions based on reliable data.
            </p>
            <a href="/tell-me-more" className="btn-primary inline-flex items-center">
              Start Your Data Journey
              <ArrowRight className="ml-2 h-4 w-4" />
            </a>
          </div>
          
          <div className="reveal">
            <img 
              src="/lovable-uploads/3c03ee31-0001-483f-b438-90f176a19a7f.png" 
              alt="Data Platform Adoption Framework" 
              className="rounded-lg shadow-md border border-border"
            />
            <p className="text-sm text-muted-foreground mt-3 text-center">
              Our comprehensive data platform adoption framework guides your journey to data-driven operations
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IntroSection;
